/**
 * Utilitaires pour les commandes
 */

/**
 * Formate une date au format français
 */
export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

/**
 * Formate un prix en euros
 */
export const formatPrice = (price) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
};

/**
 * Vérifie si une commande peut être annulée
 */
export const canCancelOrder = (order) => {
  return ['pending', 'confirmed'].includes(order.status);
};

/**
 * Retourne la couleur du statut
 */
export const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'confirmed':
      return 'info';
    case 'processing':
      return 'primary';
    case 'shipped':
      return 'secondary';
    case 'delivered':
      return 'success';
    case 'cancelled':
      return 'error';
    default:
      return 'default';
  }
};

/**
 * Retourne l'icône du statut
 */
export const getStatusIcon = (status) => {
  switch (status) {
    case 'pending':
      return 'ScheduleIcon';
    case 'confirmed':
      return 'CheckCircleIcon';
    case 'processing':
      return 'LocalShippingIcon';
    case 'shipped':
      return 'CheckCircleIcon';
    case 'delivered':
      return 'CheckCircleIcon';
    case 'cancelled':
      return 'CancelIcon';
    default:
      return null;
  }
};

/**
 * Retourne le libellé du statut
 */
export const getStatusLabel = (status) => {
  const labels = {
    pending: 'En attente',
    confirmed: 'Confirmée',
    processing: 'En cours',
    shipped: 'Expédiée',
    delivered: 'Livrée',
    cancelled: 'Annulée',
  };
  return labels[status] || status;
};
